<template>
  <div>
    <div v-if="stock.www_desc_chi" class="www-desc">{{ stockDescription }}</div>
    <div v-else class="www-desc">&nbsp;</div>
  </div>
</template>

<script>
export default {
  props: ['stock', 'chiLimit', 'engLimit'],
  computed: {
    stockDescription() {
      let desc = this.stock.www_desc_chi;
      if (this.$i18n.locale === 'en' && this.stock.www_desc_eng) {
        desc = this.stock.www_desc_eng;
      }
      if (this.$i18n.locale === 'en' && desc.length > this.engLimit) {
        desc = desc.slice(0, this.engLimit);
        desc = `${desc}...`;
      }
      if (this.$i18n.locale !== 'en' && desc.length > this.chiLimit) {
        desc = desc.slice(0, this.chiLimit);
        desc = `${desc}...`;
      }
      return `"${desc}"`;
    },
  },
};
</script>

<style scoped>
.www-desc {
  font-size: 15.4px;
  font-weight: 700;
}
</style>